import type { IFupLogo } from "@bbj-types/organisation";
import type { TPartnerFeedbackFormResolver } from "./partnerFeedback/resolver";

export const formatSponsorsLogo = (fupLogos: IFupLogo[], sponsorsLogo: IFupLogo[], financedByFSE: boolean) => {
  return financedByFSE ? [...fupLogos.filter((logo) => logo.value === "fse"), ...sponsorsLogo] : sponsorsLogo;
};

export const formatPartnerFeedback = (partnerFeedback: TPartnerFeedbackFormResolver["partnerFeedback"]) => ({
  ...partnerFeedback,
  address: partnerFeedback.address ?? undefined,
});
